(function ($) {
	$('.masonry').isotope({
		itemSelector: '.masonry-item',
		percentPosition: true,
		masonry: {
			columnWidth: '.masonry-sizer',
			gutter: 9,
		}
	});

	var swipers = [];
	function slider() {
		var sliders = $('.masonry');

		if(swipers.length > 0){
			swipers.forEach((swiper) => {
				swiper.destroy()
			});
		}
		sliders.each(function () {
			var $slider = $(this);
			swipers.push( new Swiper($slider.find('.masonry-lightbox-swiper').get(0), {
				speed: 300,
				lazy: {
					loadPrevNext: true,
					loadPrevNextAmount: 2
				},
				navigation: {
					nextEl: ".masonry-lightbox-arrow-next",
					prevEl: ".masonry-lightbox-arrow-prev",
				},
			}));
			$slider.swiper = swipers[swipers.length - 1];

			$slider.find("[data-open-lightbox-masonry]").click(function () {
				var init_slide = parseInt($(this).attr('data-masonry-lightbox-slide-to'))
				setTimeout(() => {
					$slider.addClass('masonry-lightbox-open');
					$slider.swiper.slideTo(init_slide-1)
					$slider.swiper.update()

				}, 1)
			})

			$slider.find("[data-close-lightbox-masonry]").click(function () {
				$slider.removeClass('masonry-lightbox-open');
			})

			$(document).keyup(function (e) {
				if (e.key === "Escape") { // escape key maps to keycode `27`
					$slider.removeClass('masonry-lightbox-open');
				}
			});

		});
	}

	var w = $(window).width();
	window.addEventListener('resize', () => {
		if ($(window).width() === w) return;
		w = $(window).width();
		slider();
	});

	$(document).gp_ready(function (){
		slider();
	});




})(jQuery);
